import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { ChurnFlowAnalyticsI } from '@core/churn-flow-types';
import { AppKind, injectTellentAppKind } from '@core/tellent-types';

@Injectable()
export class ChurnFlowAnalyticsBaseService extends AnalyticsBase {
  private readonly app: AppKind = injectTellentAppKind();

  public readonly namespace: string = 'Churn';
  public readonly requireViewContext: boolean = false;

  public trackCancelSubscriptionStarted(): void {
    this.track('CancelSubscriptionStarted', { app: this.app });
  }

  public trackStayWithTellent(data: ChurnFlowAnalyticsI): void {
    this.track('StayWithTellent', { app: this.app, ...data });
  }

  public trackStepOneContactSupport(): void {
    this.track('Step1_ContactSupport', { app: this.app });
  }

  public trackStepOneModifyMyPlan(): void {
    this.track('Step1_ModifyPlan', { app: this.app });
  }

  public trackStepOneContinue(): void {
    this.track('Step1_ContinueWithCancellation', { app: this.app });
  }

  public trackStepTwoContinue(data: ChurnFlowAnalyticsI): void {
    this.track('Step2_ReasonSelected', { app: this.app, ...data });
  }

  public trackStepThreeContinue(data: ChurnFlowAnalyticsI): void {
    this.track('Step3_ContinueWithCancellation', { app: this.app, ...data });
  }

  public trackStepFourContinue(data: ChurnFlowAnalyticsI): void {
    this.track('Step4_CompleteCancellation', { app: this.app, ...data });
  }

  public trackFarewellStepContinue(data: ChurnFlowAnalyticsI): void {
    this.track('SubscriptionCancelled', { app: this.app, ...data });
  }
}
